import React from 'react';
import { EyeIcon, BrainIcon, MaximizeIcon, FlameIcon, ShieldIcon, CompassIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
import { CTAButton } from './CTAButton';
import { benefits } from '../data/content';
const icons = {
  eye: EyeIcon,
  brain: BrainIcon,
  expand: MaximizeIcon,
  flame: FlameIcon,
  shield: ShieldIcon,
  compass: CompassIcon
};
export function BenefitsSection() {
  return <section className="relative isolate overflow-hidden border-t border-gold-500/10 bg-void-900 py-24 md:py-32" data-id="element-16" data-mp="38ud9cgvadowc">
      <div className="neon-grid pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" data-id="element-17" data-mp="2zrlz2ke5cz6a" />
      <div className="relative mx-auto max-w-6xl px-6" data-id="element-18" data-mp="34q5oiury8t3e">
        <Reveal className="max-w-2xl" data-id="element-19" data-mp="34qp3q3q7t3dq">
          <SectionLabel data-id="element-20" data-mp="y08wi1znj3de">Lo que cambia en ti</SectionLabel>
          <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-5xl" data-id="element-21" data-mp="y0qxfbx9e5rn">
            Beneficios que sentirás mientras lees.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-bone-300 sm:text-lg" data-id="element-22" data-mp="2bdut2vqd4mda">
            No son promesas mágicas. Son cambios de perspectiva que ocurren cuando decides mirar
            con otros ojos.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-px overflow-hidden rounded-sm border border-white/5 bg-white/5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-23" data-mp="2l6tkeld8ur0l">
          {benefits.map((benefit, i) => {
          const Icon = icons[benefit.icon];
          return <li key={benefit.title} className="bg-void-900" data-id="element-24" data-mp="1ofrm4mbibw3o" data-mpi={i}>
                <Reveal delay={i % 3 * 0.06} className="h-full" data-id="element-25" data-mp="22ehke5a2c1tm">
                  <div className="group h-full p-8 transition-all duration-300 hover:bg-void-800 hover:shadow-[inset_0_0_60px_rgba(34,227,127,0.08)]" data-id="element-26" data-mp="22fso653id9kq">
                    <Icon className="h-5 w-5 text-gold-500 drop-shadow-[0_0_10px_rgba(34,227,127,0.6)] transition-transform duration-300 group-hover:scale-110" aria-hidden="true" data-id="element-27" data-mp="3dt4s0fz9ps6w" />
                    <h3 className="mt-6 font-display text-2xl font-light text-bone-50" data-id="element-28" data-mp="3guzksz7jzn72">
                      {benefit.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-bone-300" data-id="element-29" data-mp="3pvfni6gh2qav">{benefit.text}</p>
                  </div>
                </Reveal>
              </li>;
        })}
        </ul>

        <Reveal delay={0.1} data-id="element-30" data-mp="2x7s3otn103pa">
          <div className="mt-12 flex justify-center" data-id="element-31" data-mp="2x8l1h540biva">
            <CTAButton label="Sí, estoy listo" variant="outline" data-id="element-32" data-mp="3263fh9wvsoa5" />
          </div>
        </Reveal>
      </div>
    </section>;
}